import { Component, Input, Output, EventEmitter } from '@angular/core';

import { VoyagePartialService } from './voyage-partial.service';
import { Trip } from './../../models';

@Component({
  selector: 'voyage-partial',
  template: require('./voyage-partial.component.html'),
  styles: [require('./voyage-partial.component.scss')],
  providers: [VoyagePartialService]
})
export class VoyagePartialComponent {
  public trip: Trip;

  @Output() onShare: EventEmitter<any> = new EventEmitter();
  @Output() onContact: EventEmitter<Trip> = new EventEmitter();

  constructor(private service: VoyagePartialService) {
  }

  @Input()
  set item(trip: Trip) {
    this.trip = trip;
  }

  share(): void {
    this.onShare.emit();
  }

  contact(): void {
    this.onContact.emit(this.trip);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/components/voyage-partial/voyage-partial.component.ts